import { Box, Typography } from '@mui/material'
import { inject, observer } from 'mobx-react'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import AssignedDealer from '../../../../components/customElements/RequestDataAccordions/AssignedDealer'
import RightDrawer from '../../../../components/customElements/RightDrawer/RightDrawer'
import {
  isAdmin,
  isAdministration,
  isDealer,
  isLooker,
  isOperator,
  isSuperOperator,
} from '../../../../services/AccountService'
import {
  closeModalFn,
  isModalOpen,
} from '../../../../utils/controllers/ModalController'
import RequestReportActions from '../../../SingleServiceReport/RequestReportActions/RequestReportActions'
import ApplicationServicingAccordion from './DrawersCommonComponents/ApplicationServicingAccordion'
import AcceptBtn from './DrawersCommonComponents/Buttons/AcceptBtn'
import DuplicateBtn from './DrawersCommonComponents/Buttons/DuplicateBtn'
import GuaranteeRepairBtn from './DrawersCommonComponents/Buttons/GuaranteeRepairBtn'
import OnSiteRepairBtn from './DrawersCommonComponents/Buttons/OnSiteRepairBtn'
import ProblemSolvedRemotely from './DrawersCommonComponents/Buttons/ProblemSolvedRemotely'
import ReturnForRevisionBtn from './DrawersCommonComponents/Buttons/ReturnForRevisionBtn'
import ServiceIsNotPossible from './DrawersCommonComponents/Buttons/ServiceIsNotPossible'
import StartServiceBtn from './DrawersCommonComponents/Buttons/StartServiceBtn'
import TakeReleaseBtn from './DrawersCommonComponents/Buttons/TakeReleaseBtn'
import ToGuaranteeRepair from './DrawersCommonComponents/Buttons/ToGuaranteeRepair'
import CommentsAccordion from './DrawersCommonComponents/CommentsAccordion'
import FullEquipmentDataAccordion from './DrawersCommonComponents/FullEquipmentDataAccordion'
import NewEquipmentDataAcc from './DrawersCommonComponents/NewEquiopmentDataAcc'
import ReasonDescriptionAccordion from './DrawersCommonComponents/ReasonDescriptionAccordion'
import ReportServiceInformationAccordion from './DrawersCommonComponents/ReportServiceInformationAccordion'
import ServiceInformationAccordion from './DrawersCommonComponents/ServiceInformationAccordion'
import StatusInfoAndEdit from './DrawersCommonComponents/StatusInfoAndEdit'
import SubscriberData from './DrawersCommonComponents/SubscriberData'

const CommonServiceDrawer = ({
  ordersStore,
  operatorStore,
  serviceStore,
  serviceSelectOrdersStore,
}) => {
  const { toggleAssignDealerDrawer, clearSelectOrder } =
    serviceSelectOrdersStore
  const {
    setShowInfoDrawer,
    clearCheckedSeviceOrder,
    onCloseDrawer,
    currentServiceData,
    acceptServiceOrderFunc, // принять заявку на обслуживание
    beginWorkWithOrderFunc, // начать работу с заявкой
    toggleStatusOnly,
    setToggleStatusOnly,
    updateOrders,
    serviceInformationAccordionFormStore,
    getServiceComments,
    setOnSiteDrawerType,
  } = serviceStore

  const handleCloseInfoDrawer = () => {
    clearCheckedSeviceOrder()
    onCloseDrawer()
    setShowInfoDrawer(null)
    clearSelectOrder()
    setToggleStatusOnly(true)
    closeModalFn['common-service-drawer']()
    serviceInformationAccordionFormStore.clear()
  }

  const showCommentsBlock = () => {
    switch (true) {
      case isAdministration():
        return currentServiceData?.status === 1

      default:
        return true
    }
  }

  const guaranteeRepairStatus = () => {
    return (
      currentServiceData?.status === 6.4 || currentServiceData?.status === 6.5
    )
  }

  const canEditSubscriberData =
    isDealer() &&
    (14 === currentServiceData?.status ||
      ([6.2, 6.5].includes(currentServiceData?.status) &&
        currentServiceData?.dataCheckingStatus === 2))

  return (
    <RightDrawer
      open={isModalOpen['common-service-drawer']}
      onClose={handleCloseInfoDrawer}
      titleComp={
        <Box className={'fx-col'}>
          <Typography variant={'subtitle1'} color={'common.white'}>
            <FormattedMessage
              id={`Заявка на обслуживание №${String(
                currentServiceData?.id,
              ).padStart(6, '0')}`}
            />
          </Typography>
        </Box>
      }
    >
      {currentServiceData && (
        <>
          <StatusInfoAndEdit
            ordersStore={ordersStore}
            currentServiceData={currentServiceData}
            tab={operatorStore?.selectedTab ?? -1}
          />

          <Box sx={toggleStatusOnly ? { display: 'none' } : null}>
            {(isAdmin() || isSuperOperator()) &&
              !guaranteeRepairStatus() &&
              !(currentServiceData?.status === 10) && (
                <AssignedDealer
                  request={currentServiceData}
                  defaultOpenState={true}
                  onEdit={
                    !isLooker() &&
                    !isOperator() &&
                    [1, 2].includes(currentServiceData?.status)
                      ? () => toggleAssignDealerDrawer([currentServiceData?.id])
                      : null
                  }
                />
              )}
            {currentServiceData.status === 6 &&
            currentServiceData.ticketStatus === 2 &&
            !canEditSubscriberData ? (
              <FullEquipmentDataAccordion
                isEditable={currentServiceData.isEquipmentIdEditable}
                serviceStore={serviceStore}
              />
            ) : (
              <ReasonDescriptionAccordion
                equipmentId={currentServiceData.equipmentId}
                serviceOrderId={currentServiceData.id}
                preventEdit={isLooker() || isOperator()}
                serviceStore={serviceStore}
              />
            )}

            <SubscriberData
              operatorStore={operatorStore}
              serviceStore={serviceStore}
              preventEdit={
                operatorStore?.selectedTab === 2 &&
                ![1, 20, 21, 24].includes(currentServiceData.status)
              }
            />
            <NewEquipmentDataAcc
              request={currentServiceData}
              updateCurrentServiceData={serviceStore.updateCurrentServiceData}
            />
            {![6.2, 6.4, 8].includes(currentServiceData.status) &&
              currentServiceData.status < 12 &&
              (currentServiceData.ticketStatus === 2 ||
                currentServiceData.ticketStatus === 3 ||
                canEditSubscriberData ||
                guaranteeRepairStatus()) && (
                <ServiceInformationAccordion
                  serviceStore={serviceStore}
                  type={
                    currentServiceData.ticketStatus === 3 ||
                    guaranteeRepairStatus()
                      ? 2
                      : 1
                  }
                />
              )}
            {([6.2, 6.4, 8].includes(currentServiceData.status) ||
              currentServiceData.status >= 12) && (
              <ReportServiceInformationAccordion
                serviceStore={serviceStore}
                type={
                  currentServiceData.ticketStatus === 3 ||
                  guaranteeRepairStatus()
                    ? 2
                    : 1
                }
              />
            )}
            {(currentServiceData.status === 11 ||
              currentServiceData.status === 7) && (
              <ApplicationServicingAccordion serviceStore={serviceStore} />
            )}

            {showCommentsBlock() && !isLooker() && (
              <CommentsAccordion
                serviceStore={serviceStore}
                canAddComment={
                  !(
                    (isOperator() && currentServiceData.status === 24) ||
                    [12, 13, 15, 16, 30].includes(currentServiceData.status)
                  )
                }
              />
            )}

            {isDealer() && currentServiceData.status === 6.3 ? (
              <GuaranteeRepairBtn />
            ) : null}

            {isOperator() &&
              [11, 24].includes(currentServiceData?.status) &&
              operatorStore?.selectedTab === 3 && (
                <TakeReleaseBtn
                  data={currentServiceData}
                  store={serviceStore}
                />
              )}
            {isDealer() && (
              <Box sx={btnsWrapperSx}>
                {currentServiceData.status === 2 ? (
                  <AcceptBtn
                    currentServiceData={currentServiceData}
                    action={acceptServiceOrderFunc}
                  />
                ) : null}
                {currentServiceData.status === 4 ? (
                  <>
                    <StartServiceBtn
                      currentServiceData={currentServiceData}
                      action={beginWorkWithOrderFunc}
                    />
                    <ProblemSolvedRemotely />
                    <ReturnForRevisionBtn />
                    <ServiceIsNotPossible />
                  </>
                ) : null}
                {currentServiceData.status === 5 ? (
                  <>
                    <OnSiteRepairBtn
                      currentServiceData={currentServiceData}
                      setOnSiteDrawerType={setOnSiteDrawerType}
                    />
                    <ToGuaranteeRepair
                      currentServiceData={currentServiceData}
                      setOnSiteDrawerType={setOnSiteDrawerType}
                    />
                    <ReturnForRevisionBtn />
                    <ServiceIsNotPossible />
                  </>
                ) : null}

                <RequestReportActions
                  request={currentServiceData}
                  updateOrders={updateOrders}
                  getServiceComments={getServiceComments}
                  isRequestTable
                />
              </Box>
            )}
            {isSuperOperator() && currentServiceData?.status === 1 && (
              <Box sx={btnsWrapperSx}>
                <DuplicateBtn />
              </Box>
            )}
          </Box>
        </>
      )}
    </RightDrawer>
  )
}

const btnsWrapperSx = {
  margin: '16px',
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  paddingBottom: '32px',
}

export default inject('serviceStore')(observer(CommonServiceDrawer))
